import panel from "./panel.png";

import modal_1 from "./modal_1.svg";
import modal_2 from "./modal_2.svg";
import modal_3 from "./modal_3.svg";
import modal_4 from "./modal_4.svg";

import card_1 from "./card_1.svg";
import card_2 from "./card_2.svg";
import card_4 from "./card_4.svg";
import card_3 from "./card_3.svg";
import card_5 from "./card_5.svg";

import p1 from "./p1.png";
import p2 from "./p2.png";
import p3 from "./p3.png";
import p4 from "./p4.png";
import p5 from "./p5.png";

export const imgT9 = {
	panel,
	modal_1,
	modal_2,
	modal_3,
	modal_4,
	card_1,
	card_2,
	card_3,
	card_4,
	card_5,
}
export const question = {
	p1,
	p2,
	p3,
	p4,
	p5,
}